// Google Analytics 4 (GA4) utility
// Remplace REACT_APP_GA_MEASUREMENT_ID par ton ID de mesure GA4

// Utiliser l'ID depuis .env ou depuis Firebase config
import { firebaseConfig } from '../firebase';

const GA_MEASUREMENT_ID = 
  process.env.REACT_APP_GA_MEASUREMENT_ID || 
  firebaseConfig?.measurementId || 
  '';

// Initialiser Google Analytics
export const initGA = () => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!GA_MEASUREMENT_ID) {
    return;
  }

  // Vérifier si le script n'est pas déjà chargé
  if (document.querySelector(`script[src*="gtag/js?id=${GA_MEASUREMENT_ID}"]`)) {
    return;
  }

  // Charger le script Google Analytics
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script1);

  // Initialiser gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(...args) {
    window.dataLayer.push(args);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    page_path: window.location.pathname,
    send_page_view: true,
  });
};

// Tracker une page view
export const trackPageView = (path) => {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path || window.location.pathname,
  });
};

// Tracker un événement personnalisé
export const trackEvent = (eventName, eventParams = {}) => {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('event', eventName, eventParams);
};

// Événements prédéfinis pour l'application
export const analytics = {
  // Recherche
  searchPerformed: (searchTerm, resultsCount) => {
    trackEvent('search', {
      search_term: searchTerm,
      results_count: resultsCount,
    });
  },

  // Filtres
  filterApplied: (filterType, filterValue) => {
    trackEvent('filter_applied', {
      filter_type: filterType,
      filter_value: filterValue,
    });
  },

  // Profils coiffeuses
  hairstylistViewed: (hairstylistId, hairstylistName) => {
    trackEvent('hairstylist_view', {
      hairstylist_id: hairstylistId,
      hairstylist_name: hairstylistName,
    });
  },

  hairstylistFavorited: (hairstylistId) => {
    trackEvent('hairstylist_favorite', {
      hairstylist_id: hairstylistId,
    });
  },

  // Avis
  reviewSubmitted: (hairstylistId, rating) => {
    trackEvent('review_submitted', {
      hairstylist_id: hairstylistId,
      rating,
    });
  },

  // Posts/Forum
  postCreated: () => {
    trackEvent('post_created');
  },

  postViewed: (postId) => {
    trackEvent('post_view', {
      post_id: postId,
    });
  },

  commentAdded: (postId) => {
    trackEvent('comment_added', {
      post_id: postId,
    });
  },

  // Inscription
  signupStarted: () => {
    trackEvent('signup_started');
  },

  signupCompleted: (isHairstylist) => {
    trackEvent('signup_completed', {
      user_type: isHairstylist ? 'hairstylist' : 'client',
    });
  },

  // Paiement/Abonnement
  paymentInitiated: (amount) => {
    trackEvent('payment_initiated', {
      value: amount,
      currency: 'EUR',
    });
  },

  paymentCompleted: (amount) => {
    trackEvent('purchase', {
      value: amount,
      currency: 'EUR',
    });
  },

  // Navigation
  navigationClick: (destination) => {
    trackEvent('navigation_click', {
      destination,
    });
  },

  // Contact
  contactClicked: (contactType, hairstylistId) => {
    trackEvent('contact_click', {
      contact_type: contactType, // 'instagram', 'whatsapp', etc.
      hairstylist_id: hairstylistId,
    });
  },
};

